/* eslint-disable @typescript-eslint/naming-convention */
export const iconDictionary = {
  awesome: {
    // Iconos Font awesome
    ADMIN: 'fa-solid fa-cogs',
    BACK: 'fa-solid fa-arrow-left',
    BANK: 'fa-solid fa-bank',
    BARCODE: 'fa-solid fa-barcode',
    BARCODE2: 'fa-solid fa-barcode-read',
    BARCODE3: 'fa-solid fa-barcode-scan',
    BARCODE4: 'fa-solid fa-scanner-gun',
    BATCHFILE: 'fa-solid fa-wpforms',
    BILLPAYMENT: 'fa-solid fa-file-invoice-dollar',
    BUS: 'fa-solid fa-bus',
    CARDBALANCE: 'fa-solid fa-comment-dollar',
    CASHREGISTER: 'fa-solid fa-cash-register',
    CHART: 'fa-solid fa-chart-column',
    CHART2: 'fa-solid fa-chart-line',
    CHART3: 'fa-solid fa-chart-simple',
    CHECKCIRCLE: 'fa-solid fa-check-circle',
    CHECKED: 'fa-regular fa-square-check',
    CLEAN: 'fa-solid fa-eraser',
    comment: 'fa-solid fa-comments',
    COMPUTER: 'fa-solid fa-desktop',
    CREDITCARD: 'fa-regular fa-credit-card',
    CREDITCARD2: 'fa-solid fa-credit-card',
    DEFAULT: 'fa-solid fa-ellipsis',
    DEPOSIT: 'fa-solid fa-circle-dollar-to-slot',
    DEPOSIT2: 'fa-solid fa-piggy-bank',
    ELLIPSIS: 'fa-solid fa-ellipsis',
    EXCLAMATION: 'fa-solid fa-exclamation-circle',
    EYE: 'fa-solid fa-eye',
    EYESLASH: 'fa-solid fa-eye-slash',
    FAX: 'fa-solid fa-fax',
    FINANCIAL: 'fa-solid fa-money-bill-1-wave',
    GEAR: 'fa-regular fa-gear',
    genericMessage: 'fa-solid fa-message',
    GLASSES: 'fa-solid fa-glasses',
    GLASSCHART: 'fa-solid fa-magnifying-glass-chart',
    GOTO: 'fa-solid fa-arrow-right',
    GROUP: 'fa-solid fa-users-between-lines',
    KEY: 'fa-solid fa-key',
    KEYBOARD: 'fa-solid fa-keyboard-o',
    LISTCHECK: 'fa-solid fa-list-check',
    LOGIN: 'fa-solid fa-arrow-right-to-bracket',
    LOGOUT: 'fa-solid fa-sign-out',
    messageNews: 'fa-solid fa-envelope-square',
    PAYMENT: 'fa-solid fa-money-check-dollar',
    PERSON: 'fa-solid fa-user',
    PIGGYBANK: 'fa-solid fa-piggy-bank',
    POS: 'fa-solid fa-mobile-retro',
    reaction: 'fa-solid fa-thumbs-up',
    REACTIVATE: 'fa-solid fa-arrow-rotate-right',
    RECEIPT: 'fa-solid fa-receipt',
    RECTANGLELIST: 'fa-regular fa-rectangle-list',
    reservationNews: 'fa-solid fa-chair-office',
    SEARCH: 'fa-solid fa-magnifying-glass',
    SEND: 'fa-regular fa-paper-plane',
    SEND2: 'fa-solid fa-paper-plane',
    SHIELD: 'fa-solid fa-shield',
    SIGNATURE: 'fa-solid fa-signature',
    STORE: 'fa-solid fa-store',
    TEXTFILE: 'fa-solid fa-file-text-o',
    THUMBDOWN: 'fa-solid fa-thumbs-o-down',
    THUMBUP: 'fa-solid fa-thumbs-o-up',
    TICKET: 'fa-solid fa-ticket',
    TRANSFER: 'fa-solid fa-money-bill-transfer',
    THUMBSUP: 'fa-regular fa-thumbs-up',
    TURNON: 'fa-solid fa-land-mine-on',
    UNCHECKED: 'fa-regular fa-square',
    USER: 'fa-solid fa-user',
    USERS: 'fa-solid fa-users',
    WITHDRAWAL: 'fa-solid fa-money-bills',
    XMARK: 'fa-regular fa-rectangle-xmark',

    ALERT: 'fa-regular fa-bell',
    CASH: 'fa-solid fa-money-bill',
    MONEYCHECK: 'fa-solid fa-money-check',
    CLOSESHIFT: 'fa-solid fa-shop-lock',
    CONFIG2: 'icmn-wrench',
    HISTORIAL: 'fa-regular fa-clock-rotate-left',
    // MONEYSERVICES: 'fa-solid fa-bell-concierge',
    MONEYSERVICES: 'fa-solid fa-landmark',
    NOEYE: 'eye-invisible',
    OTP: 'fa-regular fa-comment-dots',
    REPORTS: 'fa-solid fa-chart-line',
  },
  /**
   * Iconos que no son Font awesome!!!
   */
  icmn: {
    ACTIVATE: 'icmn-checkmark',
    ADD: 'icmn-plus',
    ADDUSER: 'icmn-user-plus',
    APPROVE: 'icmn-checkmark',
    ATACH: 'icmn-atachment',
    AUTONEWAFFILIATION: 'icmn-profile',
    BPMCODES: 'icmn-file-text2',
    CAMARACOMERCIO: 'icmn-book',
    CANCEL: 'icmn-cross',
    CART: 'icmn-cart',
    CHAT: 'icmn-bubbles4',
    CHECK: 'icmn-checkmark',
    CLOSE: 'icmn-ungroup',
    CODES: 'icmn-file-text',
    COIN: 'icmn-coin-dollar',
    CONFIG: 'icmn-wrench',
    CONTACTS: 'icmn-address-book',
    COPY: 'icmn-copy',
    CUT: 'icmn-scissors',
    DEFAULT: 'icmn-home',
    DELETE: 'icmn-bin',
    DELIVER: 'icmn-truck',
    DETAIL: 'icmn-binoculars',
    DOWN: 'icmn-circle-down',
    DOWNLOAD: 'icmn-cloud-download',
    DOWNLOADSET: 'icmn-cloud-download',
    EARTH: 'icmn-earth',
    EDIT: 'icmn-pencil',
    ENTER: 'icmn-enter',
    ENTITY: 'icmn-library',
    EXCEL: 'icmn-file-excel',
    EXIT: 'icmn-exit',
    FACEBOOK: 'icmn-facebook',
    FILTER: 'icmn-filter',
    FIRE: 'icmn-fire',
    FOLDER: 'icmn-folder-open',
    'FORM-CREATE': 'icmn-file-empty',
    'FORM-EDIT': 'icmn-pencil2',
    FORMRECORD: 'icmn-insert-template',
    'FORM-VIEW': 'icmn-file-text2',
    GAUGE: 'icmn-meter',
    // GEAR: 'icmn-cog',
    GIFT: 'icmn-gift',
    GOOGLE: 'icmn-google',
    GRAPH: 'icmn-stats-dots',
    HAPPY: 'icmn-happy',
    HEART: 'icmn-heart',
    HEARTBROKEN: 'icmn-heart-broken',
    HOLDER: 'icmn-profile',
    HOURGLASS: 'icmn-hour-glass',
    INACTIVATE: 'icmn-cross',
    INBOXEMPTY: 'icmn-drawer2',
    INBOXFULL: 'icmn-drawer',
    INFO: 'icmn-info',
    LAB: 'icmn-lab',
    LEFT: 'icmn-circle-left',
    LINK: 'icmn-link',
    LINKEDIN: 'icmn-linkedin',
    LIST: 'icmn-list', // 'icmn-list',
    LOCATION: 'icmn-location',
    lockDoc: 'icmn-lock',
    MAP: 'icmn-map',
    MOBILE: 'icmn-mobile',
    MOBILE2: 'icmn-mobile',
    MOVEDOWN: 'icmn-arrow-down',
    MOVEUP: 'icmn-arrow-up',
    NEW: 'icmn-file-empty',
    NEWAFFILIATION: 'icmn-profile',
    NOTIFICATION: 'icmn-notification',
    OFFICE: 'icmn-office',
    PDF: 'icmn-file-pdf',
    PICTURE: 'icmn-camera',
    PIE: 'icmn-pie-chart',
    PLAY: 'icmn-play2',
    POWER: 'icmn-switch',
    PROFILE: 'icmn-profile',
    QUESTION: 'icmn-question',
    RECHARGE: 'icmn-power-cord',
    REDO: 'icmn-redo2',
    RESET: 'icmn-loop2',
    REJECT: 'icmn-cross',
    REMOVEUSER: 'icmn-user-minus',
    REQUESTS: 'icmn-stack',
    RESTART: 'icmn-file-empty',
    RIGHT: 'icmn-circle-right',
    SAD: 'icmn-sad',
    SARLAFT: 'icmn-binoculars',
    SAVE: 'icmn-floppy-disk',
    SCREENING: 'icmn-user-check',
    SELECT: 'icmn-pushpin',
    selectHolder: 'icmn-user-check',
    SELECTROW: 'icmn-checkbox-unchecked',
    SERVERPROCESS: 'icmn-cloud-check',
    SHARE: 'icmn-share',
    SORTASC: 'icmn-sort-alpha-asc',
    SORTDSC: 'icmn-sort-alpha-desc',
    SPINNER: 'icmn-spiiner3',
    STAR2: 'icmn-star-empty',
    STOP: 'icmn-stop',
    TABLE: 'icmn-table',
    TAGS: 'icmn-price-tags',
    TELEVISION: 'icmn-tv',
    TEXT: 'icmn-file-text',
    TREE: 'icmn-tree',
    TROPHY: 'icmn-trophy',
    TUNE: 'icmn-equalizer',
    TWITTER: 'icmn-twitter',
    UNCHECK: 'icmn-cross',
    UNDO: 'icmn-undo2',
    UNLOCK: 'icmn-unlocked',
    UNSELECTROW: 'icmn-checkbox-checked',
    UP: 'icmn-circle-up',
    UPLOAD: 'icmn-cloud-upload',
    validateAML: 'icmn-warning',
    VERIFY: 'icmn-clipboard',
    VIEW: 'icmn-eye',
    WARNING: 'icmn-warning',
    WHATSAPP: 'icmn-whatsapp',
    YOUTUBE: 'icmn-youtube',
    ZIPFILE: 'icmn-file-zip',
    ZOOMIN: 'icmn-zoom-in',
    ZOOMOUT: 'icmn-zoom-out',
  },
  fe: {
    'ALERT-CIRCLE': 'fe fe-alert-circle',
    'ALERT-TRIANGLE': 'fe fe-alert-triangle',
    'AT-SIGN': 'fe fe-at-sign',
    BELL: 'fe fe-bell',
    BOOK: 'fe fe-book-open',
    BOOKMARK: 'fe fe-bookmark', // 'icmn-bookmark',
    BRIEFCASE: 'fe fe-briefcase', // 'icmn-briefcase',
    CALENDAR: 'fe fe-calendar',
    CAMERA: 'fe fe-camera',
    CLIPBOARD: 'fe fe-clipboard',
    COMMAND: 'fe fe-command',
    CPU: 'fe fe-cpu',
    'CREDIT-CARD': 'fe fe-credit-card',
    DATABASE: 'fe fe-database', // 'icmn-database',
    'DOLLAR-SIGN': 'fe fe-dollar-sign',
    eventNews: 'fe fe-calendar',
    FEATHER: 'fe fe-feather',
    'FILE-PLUS': 'fe fe-file-plus',
    'FILE-TEXT': 'fe fe-file-text',
    GLOBE: 'fe fe-globe',
    GRID: 'fe fe-grid',
    'HARD-DRIVE': 'fe fe-hard-drive',
    'HELP-CIRCLE': 'fe fe-help-circle',
    HOME: 'fe fe-home', // 'icmn-home',
    IMAGE: 'fe fe-image', // 'icmn-image',
    INBOX: 'fe fe-inbox',
    LAYERS: 'fe fe-layers',
    LOCK: 'fe fe-lock', // 'icmn-lock',
    MAIL: 'fe fe-mail', // 'icmn-envelop',
    MENU: 'fe fe-menu',
    'MESSAGE-CIRCLE': 'fe fe-message-circle',
    MINUS: 'fe fe-minus',
    'MINUS-CIRCLE': 'fe fe-minus-circle',
    PERCENT: 'fe fe-percent',
    'PHONE-CALL': 'fe fe-phone-call',
    'PIE-CHART': 'fe fe-pie-chart',
    PRINTER: 'fe fe-printer',
    PIN: 'fe fe-map-pin',
    'SHOPPING-BAG': 'fe fe-shopping-bag',
    'SHOPPING-CART': 'fe fe-shopping-cart',
    SLASH: 'fe fe-slash',
    SMARTPHONE: 'fe fe-smartphone',
    STAR: 'fe fe-star', // 'icmn-star-full',
    TAG: 'fe fe-tag',
    TARGET: 'fe fe-target', // 'icmn-target',
    'TRENDING-UP': 'fe fe-trending-up',
    TRUCK: 'fe fe-truck',
    TV: 'fe fe-tv',
    TYPE: 'fe fe-type',
    'USER-CHECK': 'fe fe-user-check',
    'USER-PLUS': 'fe fe-user-plus',
    'USER-X': 'fe fe-user-x',
  }
};
